import { render, staticRenderFns } from "./VolunteerFamilyList.vue?vue&type=template&id=e2d5a2ac&scoped=true&"
import script from "./VolunteerFamilyList.vue?vue&type=script&lang=js&"
export * from "./VolunteerFamilyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d5a2ac",
  null
  
)

export default component.exports